/*
 * @Author: piaopiao.huang
 * @Date: 2021-09-16 11:31:05
 * @LastEditors: piaopiao.huang
 * @LastEditTime: 2022-07-14 14:53:28
 * @Description:
 */
import request from '@/utils/request'

export function fetchList(query) {
  return request({
    url: '/user',
    method: 'get',
    params: query
  })
}

export function fetchSimpleList(query) {
  return request({
    url: '/user/simple',
    method: 'get',
    params: query
  })
}

export function syncUser() {
  return request({
    url: '/user/sync',
    method: 'post'
  })
}

export function register(data) {
  return request({
    url: '/user',
    method: 'post',
    data
  })
}
export function deleteUser(ids) {
  return request({
    url: `/user/${ids}`,
    method: 'delete'
  })
}

export function checkUser(name) {
  return request({
    url: `/user/check/${name}`,
    method: 'get'
  })
}
export function checkEmail(name) {
  return request({
    url: `/user/check/email/${name}`,
    method: 'get'
  })
}
export function editUser(data) {
  return request({
    url: '/user',
    method: 'put',
    data
  })
}
// 获取路由菜单
export function menuUser() {
  return request({
    url: '/menu/user',
    method: 'get'
  })
}
// 同步portainer权限
export function syncPortainer(params) {
  return request({
    url: '/user/portainer',
    method: 'post',
    params
  })
}

/**
 * 获取用户信息
 * @returns {AxiosPromise}
 */
export function getUserInfo() {
  return request({
    url: '/user/info',
    method: 'get'
  })
}

/**
 * 修改用户密码
 * @param data
 * @returns {AxiosPromise}
 */
export function updateUserPassword(data) {
  return request({
    url: '/user/password',
    method: 'put',
    data
  })
}
